<template>
  <div class="app-droneviewer">
    <iframe
      v-if="iframeSource"
      id="droneviewer-iframe"
      :src="iframeSource"
      class="app-droneviewer__iframe"
    />
    <ViewButtons v-if="isDroneviewShowing" />
  </div>
</template>

<script lang="ts" setup>
import ViewButtons from '@/components/general/ViewButtons/ViewButtons.vue'
import { computed, watch, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const iframeSource = ref(null)
const isDroneviewShowing = computed(() => store.getters['isDroneviewShowing'])
const currentDroneviewLinkId = computed(() => store.state.currentDroneviewLinkId)
const selectedRealEstate = computed(() => store.state.mapview.selectedRealEstate)

watch(
  () => isDroneviewShowing.value,
  (newValue) => {
    if (newValue === true) {
      if (
        selectedRealEstate.value.droneviewLinks &&
        selectedRealEstate.value.droneviewLinks.length
      ) {
        iframeSource.value =
          selectedRealEstate.value.droneviewLinks[currentDroneviewLinkId.value].link
      } else {
        iframeSource.value = null
      }
    }
  }
)
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;

.app-droneviewer {
  background-color: old-variables.$color-grey-lighter;
  height: 100%;
  overflow: hidden;
  width: old-variables.$width-droneviewer;
  max-width: old-variables.$width-droneviewer;
  &__iframe {
    height: 100%;
    width: 100%;
    border: none;
    background-color: old-variables.$color-grey-lighter;
  }
}

@media screen and (max-width: 1024px) {
  .app-droneviewer {
    background-color: old-variables.$color-grey-light;
    position: relative;
    margin-top: variables.$layout-top-bar-height;
    height: calc(100vh - #{variables.$layout-top-bar-height});
    width: 100vw;
    max-width: 100vw;
    &__iframe {
      height: calc(100% - #{variables.$view-buttons-height});
    }
  }
}
</style>
